// localStorage autosave (single slot), mirroring the original port's
// morning-autosave format including the RNG state.
const KEY = "socher_hayam_save_v1";
const SCORES_KEY = "socher_hayam_local_scores_v1";

export function saveGame(state) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ v: 1, ...state }));
  } catch (e) {
    console.warn("autosave failed (storage unavailable)", e);
  }
}

export function loadGame() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.v !== 1 || data.day < 1 || data.day > 7) return null;
    return data;
  } catch (e) {
    console.warn("failed to load save", e);
    return null;
  }
}

export function deleteSave() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    console.warn("failed to delete save", e);
  }
}

export function hasSave() {
  return loadGame() !== null;
}

// Persisted game settings (like the port's port.cfg)
const SETTINGS_KEY = "socher_hayam_settings_v1";

export const DEFAULT_SETTINGS = {
  crewStrike: true,
  closedShipyard: true,
  fixedGuardPrice: false,
  closedPorts: true,
  bankInterest: false,
  navError: true,
  guardReserve: 4,
  soundOn: true,
};

export function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) };
  } catch (e) {
    console.warn("failed to load settings, using defaults", e);
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings) {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch (e) {
    console.warn("failed to save settings", e);
  }
}

// Local fallback for high scores when the server is unreachable
export function getLocalScores() {
  try {
    return JSON.parse(localStorage.getItem(SCORES_KEY) || "[]");
  } catch (e) {
    console.warn("failed to read local scores", e);
    return [];
  }
}

export function addLocalScore(name, score) {
  const list = getLocalScores();
  list.push({ name, score });
  list.sort((a, b) => b.score - a.score);
  const top = list.slice(0, 20);
  try {
    localStorage.setItem(SCORES_KEY, JSON.stringify(top));
  } catch (e) {
    console.warn("failed to store local scores", e);
  }
  return top;
}
